/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type AccessRequestPostRequest,
    AccessRequestPostRequestFromJSON,
    AccessRequestPostRequestToJSON,
} from '../models/AccessRequestPostRequest';
import {
    type AccessRequestsAppAccessRulePatchRequest,
    AccessRequestsAppAccessRulePatchRequestFromJSON,
    AccessRequestsAppAccessRulePatchRequestToJSON,
} from '../models/AccessRequestsAppAccessRulePatchRequest';
import {
    type AccessRequestsAppAccessRulePostRequest,
    AccessRequestsAppAccessRulePostRequestFromJSON,
    AccessRequestsAppAccessRulePostRequestToJSON,
} from '../models/AccessRequestsAppAccessRulePostRequest';
import {
    type GetAccessRequestsAppRulesMe200Response,
    GetAccessRequestsAppRulesMe200ResponseFromJSON,
    GetAccessRequestsAppRulesMe200ResponseToJSON,
} from '../models/GetAccessRequestsAppRulesMe200Response';
import {
    type GetAccessRequestsMe200Response,
    GetAccessRequestsMe200ResponseFromJSON,
    GetAccessRequestsMe200ResponseToJSON,
} from '../models/GetAccessRequestsMe200Response';

export interface DeleteAccessRequestsAppRulesRuleIDRequest {
    accessRuleId: string;
    slashIDOrgID: string;
}

export interface GetAccessRequestsAppRulesPersonsPersonIDRequest {
    personId: string;
    slashIDOrgID: string;
}

export interface GetAccessRequestsPersonsPersonIDRequest {
    personId: string;
    slashIDOrgID: string;
}

export interface PatchAccessRequestsAppRulesRuleIDRequest {
    accessRuleId: string;
    slashIDOrgID: string;
    accessRequestsAppAccessRulePatchRequest: AccessRequestsAppAccessRulePatchRequest;
}

export interface PostAccessRequestsAppRulePersonIDRequest {
    personId: string;
    slashIDOrgID: string;
    accessRequestsAppAccessRulePostRequest: AccessRequestsAppAccessRulePostRequest;
}

export interface PostAccessRequestsMeAccessRuleIDRequest {
    accessRuleId: string;
    accessRequestPostRequest: AccessRequestPostRequest;
}

/**
 * 
 */
export class IdentityProtectionApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteAccessRequestsAppRulesRuleID without sending the request
     */
    async deleteAccessRequestsAppRulesRuleIDRequestOpts(requestParameters: DeleteAccessRequestsAppRulesRuleIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessRuleId'] == null) {
            throw new runtime.RequiredError(
                'accessRuleId',
                'Required parameter "accessRuleId" was null or undefined when calling deleteAccessRequestsAppRulesRuleID().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling deleteAccessRequestsAppRulesRuleID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/app-rules/{access_rule_id}`;
        urlPath = urlPath.replace('{access_rule_id}', encodeURIComponent(String(requestParameters['accessRuleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete access rule for the given access rule ID 
     * Delete access rule for the given access rule ID
     */
    async deleteAccessRequestsAppRulesRuleIDRaw(requestParameters: DeleteAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAccessRequestsAppRulesRuleIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete access rule for the given access rule ID 
     * Delete access rule for the given access rule ID
     */
    async deleteAccessRequestsAppRulesRuleID(requestParameters: DeleteAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAccessRequestsAppRulesMe without sending the request
     */
    async getAccessRequestsAppRulesMeRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/app-rules/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all access rules of the person identified by the token 
     * Get all access rules of the person identified by the token
     */
    async getAccessRequestsAppRulesMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsAppRulesMe200Response>> {
        const requestOptions = await this.getAccessRequestsAppRulesMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsAppRulesMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all access rules of the person identified by the token 
     * Get all access rules of the person identified by the token
     */
    async getAccessRequestsAppRulesMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsAppRulesMe200Response> {
        const response = await this.getAccessRequestsAppRulesMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccessRequestsAppRulesPersonsPersonID without sending the request
     */
    async getAccessRequestsAppRulesPersonsPersonIDRequestOpts(requestParameters: GetAccessRequestsAppRulesPersonsPersonIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getAccessRequestsAppRulesPersonsPersonID().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getAccessRequestsAppRulesPersonsPersonID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/app-rules/persons/{person_id}`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all app access rules of the given person 
     * Get all app access rules of the given person
     */
    async getAccessRequestsAppRulesPersonsPersonIDRaw(requestParameters: GetAccessRequestsAppRulesPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsAppRulesMe200Response>> {
        const requestOptions = await this.getAccessRequestsAppRulesPersonsPersonIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsAppRulesMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all app access rules of the given person 
     * Get all app access rules of the given person
     */
    async getAccessRequestsAppRulesPersonsPersonID(requestParameters: GetAccessRequestsAppRulesPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsAppRulesMe200Response> {
        const response = await this.getAccessRequestsAppRulesPersonsPersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccessRequestsMe without sending the request
     */
    async getAccessRequestsMeRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all access requests of the person identified by the token 
     * Get all access requests of the person identified by the token
     */
    async getAccessRequestsMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsMe200Response>> {
        const requestOptions = await this.getAccessRequestsMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all access requests of the person identified by the token 
     * Get all access requests of the person identified by the token
     */
    async getAccessRequestsMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsMe200Response> {
        const response = await this.getAccessRequestsMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccessRequestsPersonsPersonID without sending the request
     */
    async getAccessRequestsPersonsPersonIDRequestOpts(requestParameters: GetAccessRequestsPersonsPersonIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getAccessRequestsPersonsPersonID().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getAccessRequestsPersonsPersonID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/persons/{person_id}`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all access requests of the given person 
     * Get all access requests of the given person
     */
    async getAccessRequestsPersonsPersonIDRaw(requestParameters: GetAccessRequestsPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessRequestsMe200Response>> {
        const requestOptions = await this.getAccessRequestsPersonsPersonIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccessRequestsMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all access requests of the given person 
     * Get all access requests of the given person
     */
    async getAccessRequestsPersonsPersonID(requestParameters: GetAccessRequestsPersonsPersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessRequestsMe200Response> {
        const response = await this.getAccessRequestsPersonsPersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for patchAccessRequestsAppRulesRuleID without sending the request
     */
    async patchAccessRequestsAppRulesRuleIDRequestOpts(requestParameters: PatchAccessRequestsAppRulesRuleIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessRuleId'] == null) {
            throw new runtime.RequiredError(
                'accessRuleId',
                'Required parameter "accessRuleId" was null or undefined when calling patchAccessRequestsAppRulesRuleID().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling patchAccessRequestsAppRulesRuleID().'
            );
        }

        if (requestParameters['accessRequestsAppAccessRulePatchRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestsAppAccessRulePatchRequest',
                'Required parameter "accessRequestsAppAccessRulePatchRequest" was null or undefined when calling patchAccessRequestsAppRulesRuleID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/app-rules/{access_rule_id}`;
        urlPath = urlPath.replace('{access_rule_id}', encodeURIComponent(String(requestParameters['accessRuleId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestsAppAccessRulePatchRequestToJSON(requestParameters['accessRequestsAppAccessRulePatchRequest']),
        };
    }

    /**
     * Update access levels for the given app and external person ID 
     * Update access levels for the given access level ID
     */
    async patchAccessRequestsAppRulesRuleIDRaw(requestParameters: PatchAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.patchAccessRequestsAppRulesRuleIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update access levels for the given app and external person ID 
     * Update access levels for the given access level ID
     */
    async patchAccessRequestsAppRulesRuleID(requestParameters: PatchAccessRequestsAppRulesRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchAccessRequestsAppRulesRuleIDRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postAccessRequestsAppRulePersonID without sending the request
     */
    async postAccessRequestsAppRulePersonIDRequestOpts(requestParameters: PostAccessRequestsAppRulePersonIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling postAccessRequestsAppRulePersonID().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postAccessRequestsAppRulePersonID().'
            );
        }

        if (requestParameters['accessRequestsAppAccessRulePostRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestsAppAccessRulePostRequest',
                'Required parameter "accessRequestsAppAccessRulePostRequest" was null or undefined when calling postAccessRequestsAppRulePersonID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/app-rules/persons/{person_id}`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestsAppAccessRulePostRequestToJSON(requestParameters['accessRequestsAppAccessRulePostRequest']),
        };
    }

    /**
     * Create a new access rule for the given app and external person ID 
     * Create the access rule for the given app and person
     */
    async postAccessRequestsAppRulePersonIDRaw(requestParameters: PostAccessRequestsAppRulePersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        const requestOptions = await this.postAccessRequestsAppRulePersonIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Create a new access rule for the given app and external person ID 
     * Create the access rule for the given app and person
     */
    async postAccessRequestsAppRulePersonID(requestParameters: PostAccessRequestsAppRulePersonIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.postAccessRequestsAppRulePersonIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postAccessRequestsMeAccessRuleID without sending the request
     */
    async postAccessRequestsMeAccessRuleIDRequestOpts(requestParameters: PostAccessRequestsMeAccessRuleIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessRuleId'] == null) {
            throw new runtime.RequiredError(
                'accessRuleId',
                'Required parameter "accessRuleId" was null or undefined when calling postAccessRequestsMeAccessRuleID().'
            );
        }

        if (requestParameters['accessRequestPostRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestPostRequest',
                'Required parameter "accessRequestPostRequest" was null or undefined when calling postAccessRequestsMeAccessRuleID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ip/access-requests/me/{access_rule_id}`;
        urlPath = urlPath.replace('{access_rule_id}', encodeURIComponent(String(requestParameters['accessRuleId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestPostRequestToJSON(requestParameters['accessRequestPostRequest']),
        };
    }

    /**
     * Create a new access request as the authenticated person for the given access rule 
     * Request access
     */
    async postAccessRequestsMeAccessRuleIDRaw(requestParameters: PostAccessRequestsMeAccessRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIResponseBase>> {
        const requestOptions = await this.postAccessRequestsMeAccessRuleIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIResponseBaseFromJSON(jsonValue));
    }

    /**
     * Create a new access request as the authenticated person for the given access rule 
     * Request access
     */
    async postAccessRequestsMeAccessRuleID(requestParameters: PostAccessRequestsMeAccessRuleIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIResponseBase> {
        const response = await this.postAccessRequestsMeAccessRuleIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
